import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Search from './pages/Search';
import CreateAgent from './pages/CreateAgent';
import Settings from './pages/Settings';
import UserManager from './pages/UserManager';
import PendingUploads from './pages/PendingUploads';
import PendingQueue from './pages/PendingQueue';
import Blacklist from './pages/Blacklist';
import CityPorts from './pages/CityPorts';
import AgentSuggestions from './pages/AgentSuggestions';
import MasterDataManager from './pages/MasterDataManager';


function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/create-agent" element={
              <ProtectedRoute requiredRoles={['Admin', 'Editor', 'Editor Branch']}>
                <Layout>
                  <CreateAgent />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/pending-uploads" element={
              <ProtectedRoute requiredRoles={['Admin', 'Editor', 'Editor Branch']}>
                <Layout>
                  <PendingUploads />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/pending-queue" element={
              <ProtectedRoute requiredRoles={['Admin', 'Editor', 'Editor Branch']}>
                <Layout>
                  <PendingQueue />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/blacklist" element={
              <ProtectedRoute requiredRoles={['Admin', 'Editor', 'Editor Branch', 'User', 'User Branch']}>
                <Layout>
                  <Blacklist />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/search" element={
              <ProtectedRoute>
                <Layout>
                  <Search />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute requiredRoles={['Admin']}>
                <Layout>
                  <Settings />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/users" element={
              <ProtectedRoute requiredRoles={['Admin']}>
                <Layout>
                  <UserManager />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/city-ports" element={
              <ProtectedRoute requiredRoles={['Admin', 'Editor', 'Editor Branch']}>
                <Layout>
                  <CityPorts />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/agent-suggestions" element={
              <ProtectedRoute requiredRoles={['Admin', 'Editor', 'Editor Branch']}>
                <Layout>
                  <AgentSuggestions />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/master-data" element={
              <ProtectedRoute requiredRoles={['Admin', 'Editor', 'Editor Branch']}>
                <Layout>
                  <MasterDataManager />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
